/**
 * Stub for @capacitor/core when building for web
 * Capacitor functionality is only available on native platforms
 */

export const Capacitor = {
  getPlatform: () => 'web' as const,
  isNativePlatform: () => false,
  isPluginAvailable: () => false,
  convertFileSrc: (path: string) => path,
};

export const registerPlugin = () => ({});

export const WebPlugin = class {};

export const CapacitorException = class extends Error {};

export const PluginListenerHandle = class {};
